import type { UserRole } from '@/types/next-auth';

/** 공개 라우트 (인증 불필요) */
// 안정화 (2026-08-19): '/share/:accessId' 제거 — 화면이 삭제됐다.
export const PUBLIC_ROUTES = ['/', '/join'];

/**
 * 보호 라우트: prefix -> 최소 역할
 * 순서 중요: 긴 prefix가 먼저 매칭되도록 내림차순 정렬
 */
export const PROTECTED_ROUTES: { prefix: string; minRole: UserRole }[] = [
  { prefix: '/admin/system', minRole: 'SUPER_ADMIN' },
  { prefix: '/admin', minRole: 'ADMIN' },
  { prefix: '/templates', minRole: 'STAFF' },
  // 엑셀 정리/취합 - 견본이 실제 학생 데이터라 담당자만(계획 2026-09-16 §5).
  { prefix: '/intake', minRole: 'STAFF' },
  { prefix: '/dashboard', minRole: 'USER' },
  { prefix: '/documents', minRole: 'USER' },
  { prefix: '/programs', minRole: 'USER' },
  { prefix: '/teams', minRole: 'USER' },
  { prefix: '/timetable', minRole: 'USER' },
  { prefix: '/ops', minRole: 'USER' },
  // 동의 화면은 로그인한 사람의 것이다. NOT_AGREED 가드가 로그인 뒤에만 보내지만,
  // 주소를 직접 치면 비로그인 200 이 났다 (2026-09-06 QA G2). /admin/system/consent
  // 는 위 /admin/system 이 먼저 잡는다.
  { prefix: '/consent', minRole: 'USER' },
  { prefix: '/prefill', minRole: 'USER' },
  { prefix: '/settings', minRole: 'USER' },
  { prefix: '/my-issues', minRole: 'USER' },
  // 작성 주소는 로그인한 본인만 연다(2026-10-06 사람 「로그인 요구해야지」). 서버도 작성 링크 토큰을
  // 로그인한 수신자에게만 준다 - 여기는 비로그인을 로그인으로 보냈다가 돌려보내는 자리다.
  { prefix: '/guest-apply', minRole: 'USER' },
  { prefix: '/ai-editor', minRole: 'USER' },
];

/** 인증된 사용자의 기본 랜딩 */
export function getDefaultRoute(_role: UserRole | undefined): string {
  void _role;
  return '/dashboard';
}

/** 주어진 pathname에 필요한 최소 역할 반환. 매칭 없으면 null(공개). */
export function getRequiredRole(pathname: string): UserRole | null {
  for (const route of PROTECTED_ROUTES) {
    if (pathname === route.prefix || pathname.startsWith(route.prefix + '/')) {
      return route.minRole;
    }
  }
  return null;
}
